import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { TipoUnidadeModel } from "../laudos-cd/tipo-unidade.model";
import { TipoUnidadeService } from "../laudos-cd/tipo-unidade.service";
import { Funcoes } from "../funcoes";
import { Global } from "../global";


@Component({
  selector: 'app-tipo-unidade-form',
  templateUrl: './tipo-unidade-form.component.html'
})
export class TipoUnidadeFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  tipoUnidade: TipoUnidadeModel = new TipoUnidadeModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private tipoUnidadeService: TipoUnidadeService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_en: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_es: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]]
    });
  }

  ngOnInit() {

    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_tipo_unidade'];

      if(!this.pageIsUpd && !this.pageIsAdd){
        this.title = this.func.traduzir('front.visualizarTipoUnidade');
      }else if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarTipoUnidade');
      }else{
        this.title = this.func.traduzir('front.cadastrarNovoTipoUnidade');
      }

      if (!id) {
        return;
      }

      this.tipoUnidadeService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTipoUnidade')+': '+json.Payload[0].nome_pt;
            }else if(!this.pageIsAdd){
              this.title = this.func.traduzir('front.visualizarTipoUnidade') + ': ' + json.Payload[0].nome_pt;
            }

            this.tipoUnidade = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.tipoUnidadeService.editar(values, values.id);
    } else {
      result = this.tipoUnidadeService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'tipo-unidade']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/tipo-unidade/tipo-unidade-form.component.ts